import enums from 'scoreboard/components/enums'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER } = DataType

/**
 * Returns the appropriate i18n key used to display a message to the user, based
 * on the given dataType.
 */
function dataTypeKey(dataType) {
	// the default language for Number when editing a metric is to call it
	// "standard", but for datasets we want it to say "number"
	if (dataType === NUMBER) {
		return 'scorecards.node.metric.dataType.number'
	}
	return enums.dataType[dataType]
}

export default dataTypeKey

dataTypeKey.__filename__ = 'datasets/data-type-key.js'
